import { CSSObject } from 'styled-components';
import { FdrAgencyBrand } from '@hotelplan/supergraph-api';
import { FdrAgencyFragment } from 'schemas/fragment/agency/fdr-agency.generated';

const SELECTED_AGENCY_PIN = `agency-pin-selected`;
const AGENCY_PIN = `agency-pin`;

const mainAgencies = [FdrAgencyBrand.Travelhouse, FdrAgencyBrand.Tpt];

const agencyIconsMap = {
  [FdrAgencyBrand.Hotelplan]: `hotelplanpin`,
  [FdrAgencyBrand.Travelhouse]: `travelhousepin`,
  [FdrAgencyBrand.Sv]: `sv-white`,
  [FdrAgencyBrand.Tpt]: `tpt-white`,
};

export function agencyZIndex(agency: FdrAgencyFragment): CSSObject {
  return mainAgencies.includes(agency.brand) ? { zIndex: 1 } : {};
}

interface IAgencyIcon {
  agencyIcon: string;
  pinIcon: string;
}

export function getAgencyIcons(
  agency: FdrAgencyFragment,
  selected = false
): IAgencyIcon {
  return {
    agencyIcon: agencyIconsMap[agency.brand] || '',
    pinIcon: selected ? SELECTED_AGENCY_PIN : AGENCY_PIN,
  };
}
